"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
const lodash_1 = require("lodash");
const react_1 = require("react");
const common_1 = require("../common");
const design_system_1 = require("@zapier/design-system");
const common_utils_1 = require("@zapier/common-utils");
const FieldFocusContext_1 = require("../FieldFocusContext");
const Styles = common_utils_1.labelStyles(__filename, {
    root: { display: 'flex' },
    textInput: { flex: 1 },
    wrapper: (screenSize) => {
        const isSmallScreen = screenSize === 'small';
        return {
            alignItems: 'center',
            display: isSmallScreen ? 'block' : 'flex',
            paddingRight: isSmallScreen ? 15 : `0 !important`,
            height: isSmallScreen ? 'auto !important' : 40,
            textAlign: isSmallScreen ? 'center' : 'inherit',
            button: {
                '&::before': {
                    border: 'none',
                },
            },
        };
    },
    input: (screenSize) => ({
        flexGrow: 1,
        width: screenSize === 'small' ? '100%' : 'auto',
    }),
    inlineText: (opts) => ({
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: design_system_1.Colors.grey700,
        paddingRight: opts.position === 'after' ? 10 : 2,
    }),
});
function getFullValue({ beforeInputText, value, afterInputText, }) {
    return `${beforeInputText}${value}${afterInputText}`;
}
const CopyToClipboardInput = (props) => {
    const fullValue = getFullValue(props);
    const [didCopy, handleCopyText] = design_system_1.useCopyToClipboard(fullValue);
    const inputRef = react_1.useRef();
    const tooltipId = lodash_1.uniqueId(`copy-to-clipboard-tooltip-`);
    const copiedLabel = didCopy ? 'Copy' : 'Copied';
    const onChange = (e) => {
        props.onChange(e.target.value.trim());
    };
    return (common_utils_1.isolateComponent(FieldFocusContext_1.ExclusiveFieldFocus, null,
        common_utils_1.isolateComponent("div", { css: Styles.root },
            common_utils_1.isolateComponent("div", { css: Styles.textInput },
                common_utils_1.isolateComponent(common_1.Input, Object.assign({}, props, { onBlur: props.onBlur, onChange: onChange }), (inputProps) => {
                    const { css } = inputProps, rest = __rest(inputProps, ["css"]);
                    const { screenSize } = props;
                    return (common_utils_1.isolateComponent("div", { css: [css, Styles.wrapper(screenSize)] },
                        props.beforeInputText && (common_utils_1.isolateComponent("div", { css: Styles.inlineText({
                                position: 'before',
                            }), onClick: () => inputRef.current.focus(), role: "presentation" }, props.beforeInputText)),
                        common_utils_1.isolateComponent("input", Object.assign({}, rest, { css: [Styles.input(screenSize)], readOnly: lodash_1.isEmpty(props.beforeInputText) &&
                                lodash_1.isEmpty(props.afterInputText), ref: inputRef, value: inputProps.value })),
                        props.afterInputText && (common_utils_1.isolateComponent("div", { css: Styles.inlineText({
                                position: 'after',
                            }), onClick: () => inputRef.current.focus(), role: "presentation" }, props.afterInputText)),
                        common_utils_1.isolateComponent(design_system_1.Button, { ariaLabel: copiedLabel, borderRadiusSide: screenSize === 'small' ? undefined : 'right', color: "grey", disabled: !props.value, onClick: e => {
                                e.preventDefault();
                                handleCopyText();
                            }, size: "small" },
                            "Copy",
                            didCopy && (common_utils_1.isolateComponent(design_system_1.Tooltip, { id: tooltipId, position: "south" }, "Copied to clipboard!")))));
                })))));
};
CopyToClipboardInput.defaultProps = {
    onBlur: () => { },
    onChange: () => { },
    afterInputText: '',
    beforeInputText: '',
};
exports.default = CopyToClipboardInput;
